import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_EXTENSION = '.xlsx';
const CSV_EXTENSION = '.csv';
const CSV_TYPE = "text/csv;charset=utf-8";

@Injectable({
  providedIn: 'root',
})
export class ExportService {
  columnsOrder = [
    'id',
    'Intitulé de la fraude',
    'Raison sociale',
    'Zone',
    'Pays / BU',
    "Secteur d'activité / Région",
    'Entité',
    'Code Vector',
    'Date de création fraude',
    'Date de modification fraude',
    'Declarée par',
    'Transferé à',
    'Activité concernée par la fraude',
    'Description de la fraude',
    'Processus concerné par la fraude',
    'Commentaires processus',
    'Défaillance de contrôle interne concernée par la fraude',
    'Fonction des personnes impliquées dans la fraude',
    'Commentaires défaillance',
    'Motivation des fraudeurs',
    'Commentaire fait',
    '(De) A quelle date les faits ont-ils été découverts ?',
    '(À) A quelle date les faits ont-ils été découverts ?',
    'Qui a mis en évidence la fraude ?',
    'La fraude a-t-elle été identifiée suite à une dénonciation ?',
    'Commentaire',
    'Montant de la fraude en Euros',
    'Commentaire montant fraude',
    "L'intégralité des éléments relatifs à la fraude est-elle déjà connue ?",
    'Commentaire relatif fraude',
    'Bénéficiaires',
    'Commentaire bénéficiaires',
    'Type de fraude',
    'Commentaire détournement bien',
    'Impact de la fraude sur le Résultat Opérationnel (En Euros)',
    'Impact de la fraude sur les flux financiers (En Euros)',
    'Des demandes de renseignements et des investigations ont-elles été engagées à la date du reporting ?',
    'Des demandes de renseignements et des investigations sont-elles en cours ?',
    'Des demandes de renseignements et des investigations sont-elles prévues ?',
    'Une procédure judiciaire et des mesures individuelles ont-elles été prises ?',
    'Le cas échéant : où en sont-elles actuellement ?',
    "Dans l'hypothèse d'un détournement : un remboursement a-t-il été effectué ?",
    'Quel est son montant ? (en Euros)',
    "Des plans d'action ont-ils été entrepris ?",
    "Description des plans d'action",
    'D’autres mesures ont-elles été prises',
    'Préciser la nature des communications qui ont été falsifiées',
    "S'agit-il d'une erreur de bonne foi volontairement dissimulée ?",
    "S'agit-il d'une décision d'interprétation comptable ou financière manifestement et volontairement contraire aux normes ?",
    'Commentaire corruption',
    'Niveau entité',
    'Niveau parent',
    'Statut',
    'Merci de désigner la défaillance',
    'Commentaire sur les mesures prises ou en cours',
    'Commentaire fonction personnes impliquées',
    'Impact de la fraude sur le Résultat Opérationnel',
    'Impact de la fraude sur les flux financiers',
    '(De) Période pendant laquelle les faits ont été commis',
    '(À) Période pendant laquelle les faits ont été commis',
    'Statut étape',
    'Date workflow',
    'Étape workflow',
    'Étape date',
    'Étape validateur',
    'Étape suivante',
    'Campagne',
    'Date ouverture campagne',
    'Date fin campagne',
    'Dernière campagne',
  ];

  constructor() {}

  exportToExcel(
    list: any[],
    fileName: string,
    mapResults: boolean = false
  ): void {
    let mappedList;
    // Map the list of objects to match the desired column order
    if (mapResults) {
      mappedList = list.map((item) => {
        const mappedItem = {};
        for (const column of this.columnsOrder) {
          mappedItem[column] = item[column];
        }
        return mappedItem;
      });
    } else {
      mappedList = list;
    }

    // Convert the mapped list to a worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(mappedList);

    // Generate workbook and add the worksheet
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, ws, 'Sheet1');

    // Save to file
    XLSX.writeFile(workbook, `${fileName}${EXCEL_EXTENSION}`);
  }
}
